export default __webpack_public_path__ + "static/media/Loanplus.2a93084a.png";